module.exports = __webpack_public_path__ + "static/assignment-tags-cropped-1ea556ec06cf6dde8de8631ee8cdafee.png";